var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isEmpty } from "ramda";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import bg from "../../img/modinet_left_side-002.jpg";
import { WebSocketMessage } from "../../serverConnection";
import TextFieldGroup from "../common/TextFieldGroup";
var Forgot = /** @class */ (function (_super) {
    __extends(Forgot, _super);
    function Forgot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: "",
            errors: "",
        };
        _this.onChange = function (e) {
            _this.setState({ email: e.target.value }, _this.validate);
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.props.send(WebSocketMessage("login", "forgot", { email: _this.state.email }));
            _this.props.history.push("/");
        };
        _this.validate = function () {
            if (isEmpty(_this.state.email)) {
                _this.setState({ errors: "Required" });
            }
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(_this.state.email)) {
                _this.setState({ errors: "Invalid email address" });
            }
            else {
                _this.setState({ errors: "" });
            }
        };
        return _this;
    }
    Forgot.prototype.render = function () {
        var errors = this.state.errors;
        return (React.createElement("div", null,
            React.createElement("img", { src: bg, className: "bg", alt: "" }),
            React.createElement("form", { className: "auth-form", onSubmit: this.onSubmit },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col s12" },
                        React.createElement("div", { className: "card" },
                            React.createElement("div", { className: "card-content" },
                                React.createElement(TextFieldGroup, { name: "email", type: "email", label: "Email Address", value: this.state.email, onChange: this.onChange, error: errors }),
                                React.createElement("button", { className: "btn waves-effect waves-light black col s12", type: "submit", disabled: !isEmpty(this.state.errors) }, "Reset Password"),
                                React.createElement("br", null),
                                React.createElement("br", null)),
                            React.createElement("div", { className: "card-action" },
                                React.createElement(Link, { className: "right-align", to: "/login" }, "Login ?"))))))));
    };
    return Forgot;
}(Component));
export default Forgot;



//////////////////
// WEBPACK FOOTER
// ./src/components/auth/Forgot.tsx
// module id = 1282
// module chunks = 0